import classNames from 'classnames';
import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { useTranslate } from '../../../mixins/translate/translate';
import { usePatchedDropdownMenu } from '../../../utils/usePatchedDropdownMenu';
import { NullableFormattedDate } from '../../utils/NullableFormattedDate';
import { Defect } from '../Interfaces/Defect';

type Props = {
    defect: Defect;
    onEditDefect: (defect: Defect) => void;
    onRemoveDefect: (defect: Defect) => void;
};

function ActionMenu(props: Props) {
    const localTranslate = useTranslate();
    const { buttonProps, itemProps, isOpen, setIsOpen } = usePatchedDropdownMenu(2);
    const classes = classNames('btn-group text-right', { open: isOpen });

    return (
        <div className={classes}>
            <button {...buttonProps} className="btn btn-primary br2 btn-xs fs12 dropdown-toggle" data-toggle="dropdown" type="button">
                {localTranslate('common.actions')}
                <span className="caret ml5" />
            </button>
            <ul className="dropdown-menu" role="menu">
                <li
                    {...itemProps[0]}
                    onClick={() => {
                        setIsOpen(false);
                        props.onEditDefect(props.defect);
                    }}
                >
                    <a className="cursor">{localTranslate('common.edit')}</a>
                </li>
                <li
                    {...itemProps[1]}
                    onClick={() => {
                        setIsOpen(false);
                        props.onRemoveDefect(props.defect);
                    }}
                >
                    <a className="cursor">{localTranslate('common.remove')}</a>
                </li>
            </ul>
        </div>
    );
}

interface IDefectLitsEemuaProps extends ITranslateProps {
    defects: Defect[];
    defectAddEdit: string;
    onEditDefect: (defect: Defect) => void;
    onRemoveDefect: (defect: Defect) => void;
    onAddDefectClicked: (e: any) => void;
}

class DefectListEemua extends React.Component<IDefectLitsEemuaProps, Record<string, unknown>> {
    constructor(props: IDefectLitsEemuaProps) {
        super(props);

        this.state = {};
    }

    public override render() {
        return (
            <>
                <div className="section-divider mt40 mb25">
                    <span>{this.props.t('repairAdvice.repairAdvice')}</span>
                </div>
                <div className="table-responsive mb20 br-b">
                    <table className="table table-condensed table-hover">
                        <thead>
                            <tr className="bg-primary">
                                <th>{this.props.t('repairAdvice.advice')}</th>
                                <th>{this.props.t('repairAdvice.eemua')}</th>
                                <th>{this.props.t('repairAdvice.repairDate')}</th>
                                <th className="text-right">&nbsp; </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.defects.map((defect) => (
                                <tr key={defect.id}>
                                    <td>{defect.description}</td>
                                    <td>{this.props.t(`repairCategory.${defect.repairAdviceCategory}`)}</td>
                                    <td>
                                        <NullableFormattedDate value={defect.repairDate} />
                                    </td>
                                    <td className="text-right">
                                        <ActionMenu
                                            defect={defect}
                                            onEditDefect={(d: Defect) => this.props.onEditDefect(d)}
                                            onRemoveDefect={(d: Defect) => this.props.onRemoveDefect(d)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.props.defectAddEdit === 'hidden' && (
                    <div className="p12 text-right br-b" id="defect_save">
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.onAddDefectClicked(e);
                            }}
                            className="btn btn-primary btn-sm fw600 br-b"
                        >
                            {' '}
                            <span className="fa fa-plus pr5 " /> {this.props.t('repairAdvice.add')}
                        </a>
                    </div>
                )}
            </>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(DefectListEemua);
